import React from 'react';

class ResizeListener extends React.Component {

	resizeEventHandler = undefined

	UNSAFE_componentWillMount() {
		this.props.onResize()
	}

	componentDidMount() {
		window.addEventListener('resize', this.props.onResize)
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.props.onResize)
	}

	render() {
		return null
	}

}

export default ResizeListener



// WEBPACK FOOTER //
// ./src/components/ResizeListener/ResizeListener.js